module.exports = __webpack_public_path__ + "static/media/party-hat.1c01fc5d.gif";